import {
  MenuDivider,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import { without } from 'lodash';
import { useTranslation } from 'react-i18next';
import { OrderStatus } from '../../gql/graphql';

export const UnlinkedStatus = 'UNLINKED';
export const possibleOrderStatuses = [
  ...without(Object.values(OrderStatus), OrderStatus.Publishing),
  UnlinkedStatus,
];

type IfcCategoriesCheckBoxesProps = {
  setSelectedOrderStatuses: (array: string[]) => void;
  selectedOrderStatuses: string[];
};

export default function OrderStatusMenuListCheckBoxes({
  setSelectedOrderStatuses,
  selectedOrderStatuses,
}: IfcCategoriesCheckBoxesProps): React.ReactElement {
  const handleChange = (selectedOrderStatuses: string | string[]) => {
    if (Array.isArray(selectedOrderStatuses)) {
      setSelectedOrderStatuses(selectedOrderStatuses);
    } else {
      console.error('Selected table statuses should always be array');
    }
  };

  const handleAllEvent = (allEvent: string | string[]) => {
    if (allEvent.length > 0) {
      setSelectedOrderStatuses(possibleOrderStatuses);
    } else {
      setSelectedOrderStatuses([]);
    }
  };

  const { t } = useTranslation(['project', 'categories']);

  return (
    <MenuList maxHeight={'80vh'} overflow={'auto'} zIndex={99}>
      <MenuOptionGroup
        onChange={(e: string | string[]) => handleAllEvent(e)}
        type="checkbox"
        value={
          possibleOrderStatuses.length === selectedOrderStatuses.length
            ? ['all']
            : []
        }
      >
        <MenuItemOption value="all" key={'all'}>
          {t('categories:all')}
        </MenuItemOption>
      </MenuOptionGroup>
      <MenuDivider />
      <MenuOptionGroup
        onChange={(e: string | string[]) => {
          handleChange(e);
        }}
        type="checkbox"
        value={selectedOrderStatuses}
      >
        {Object.values(OrderStatus)
          .filter((value) => value !== OrderStatus.Publishing)
          .map((orderstatus) => {
            return (
              <MenuItemOption value={orderstatus} key={orderstatus}>
                {t(
                  'project:table-status.' +
                    orderstatus.toLowerCase().replace('_', '-')
                )}
              </MenuItemOption>
            );
          })}
        <MenuItemOption value={'UNLINKED'} key={'UNLINKED'}>
          {t('project:table-status.unlinked')}
        </MenuItemOption>
      </MenuOptionGroup>
    </MenuList>
  );
}
